import * as React from 'react';
import {Props} from './model';
import {PollsTypeView} from '../components/typeView';
import Screen from '../../../shared/components/screen';
import {BreadcrumbItem} from '../../../shared/components/breadcrumbs/model';
import {Routes, Screens} from '../../../shared/routing';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {useStyles} from '../../../shared/hooks/styles';
import {Container} from '../../../shared/components/container';

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: 'Опросы и голосования',
    routeName: Screens.Polls,
    webRoute: Routes.polls,
  },
  {
    title: 'Голосования',
    routeName: Screens.PollsTypeVote,
    webRoute: Routes.pollsTypeVote,
  },
];

export default ({content, pollGroups, isLoading}: Props) => {
  const styles = useStyles(() => ({
    sectionContainer: {
      position: 'relative',
      zIndex: 1,
    },
  }));

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <Container style={styles.sectionContainer}>
          <PollsTypeView
            title='Голосования'
            breadcrumbs={breadcrumbs}
            description={content.polls.voteDescription}
            pollGroups={pollGroups}
            isLoading={isLoading}
          />
        </Container>
      </CustomScrollView>
    </Screen>
  );
};
